$(document).ready(function() {

    function getCookie(name) {
      let value = `; ${document.cookie}`;
      let parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }

    let ymqUploadObserver = null;

    // Example: Retrieve the currency cookie
    let localization_currency = getCookie('localization');
    // console.log('Localization', localization_currency);

   let isPants = productTitle.includes('trousers') || productTitle.includes('pants') && !productTitle.includes('top');
   let isCap = productTitle.includes('cap');
   function toggleAddToCartButton() {
      let $addToCart = $("#populateFieldsBtn"); // Your button ID
      let hasText = $(".noemptytext").text().trim() !== "";

      // alert(hasText); // Debugging alert to check if condition works

      // Enable or disable the button based on text presence
      $addToCart.prop("disabled", !hasText);
   }

   // Open embroidery modal on button click
   $(document).on("click", ".embroideryBtn", function() {
        // On bulk order page, bulkSetEmbroideryGlobals (onclick attr) runs before this
        // handler and sets window.isPants / window.isCap for the clicked product.
        // Re-read them so placement radios and icon tab are correct.
        if (typeof window.isPants !== 'undefined') isPants = window.isPants;
        if (typeof window.isCap  !== 'undefined') isCap  = window.isCap;
        // (.reset-c1, .reset-c2 etc follow unchanged)
      $('.reset-c1, .reset-c2').trigger('click');
        //$('.ymq_upload_img_item_del').trigger('click');
      $("#logo_custom").val("").trigger('change'); // Clear file input when radio is clicked
        //$('.ymq_upload_img_item_bg .ymq_upload_img_item_del.ymq_upload_file_item_del').trigger('click');
      $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-remove').trigger('click');
    
      $('#selectedImage').css('display', 'none');
      cloneIconOptions();
      if( isPants ){
        // $('#name-placement').prop('selectedIndex', 3).trigger('change');
        $('input[name="placement-radio"][value="left-thigh-as-worn"]').prop('checked', true).trigger('change');
      } else {
        // $('#name-placement').prop('selectedIndex', 1).trigger('change');
        // console.log('radio check name');
        $('input[name="placement-radio"][value="left-chest-as-worn"]').prop('checked', true).trigger('change');
      }

      if( isPants ){
        // $('#logo-placement').prop('selectedIndex', 5).trigger('change');
        $('input[name="placement-radio-logo"][value="left-thigh-as-worn"]').prop('checked', true).trigger('change');
      } else {
        // $('#logo-placement').prop('selectedIndex', 3).trigger('change');
        $('input[name="placement-radio-logo"][value="left-chest-as-worn"]').prop('checked', true).trigger('change');
      }

      $("#embroideryModal").css("display", "block");
   });

   function cloneIconOptions() {
      if ($('.icon_content_c2 .option').length > 0) {
        // Find the highest existing icon number
        let maxIconNum = 0;
        $('input[name="properties[Icons]"]').each(function () {
          const id = $(this).attr('id');
          if (id && id.startsWith('icon')) {
            const num = parseInt(id.replace('icon', ''));
            if (!isNaN(num) && num > maxIconNum) maxIconNum = num;
          }
        });
    
        // $('.ymq-options-box[name="option-box-ymq-variant-Icons"] .spotlight-group label').each(function () {
        //   const styleAttr = $(this).attr('style') || '';
        //   const urlMatch = styleAttr.match(/url\(["']?(.*?)["']?\)/);
    
        //   if (urlMatch && urlMatch[1]) {
        //     const imgSrc = urlMatch[1];
    
        //     // Skip if already exists in .icon_content_c2
        //     const exists = $('.icon_content_c2 img').filter(function () {
        //       return $(this).attr('src') === imgSrc;
        //     }).length > 0;
    
        //     if (!exists) {
        //       const newId = `icon${++maxIconNum}`;
    
        //       const newOption = `
        //         <div class="option cloned-icon">
        //           <label for="${newId}" class="pricelabel" data-price="${window.bundlePrice}">
        //             <input type="radio" id="${newId}" class="fixrdo" style="opacity: 0;" name="properties[Icons]" value="${imgSrc}">
        //             <img src="${imgSrc}" width="65px" height="65px" alt="${newId}">
        //           </label>
        //         </div>
        //       `;
    
        //       $('.icon_content_c2 .option').last().after(newOption);
        //     }
        //   }
        // });
        $('input[name^="Icons-"]').each(function () {
            const imgSrc = $(this)
                .closest('.ymq-option-label')
                .find('.ymq-option-swatches-image')
                .attr('src');

            if (!imgSrc) return;

            const exists = $('.icon_content_c2 img[src="' + imgSrc + '"]').length > 0;
            if (exists) return;

            const newId = `icon${++maxIconNum}`;

            $('.icon_content_c2 .option').last().after(`
                <div class="option cloned-icon">
                <label for="${newId}" class="pricelabel" data-price="${window.bundlePrice}">
                    <input type="radio" id="${newId}" class="fixrdo" style="opacity:0"
                        name="properties[Icons]" value="${imgSrc}">
                    <img src="${imgSrc}" width="65">
                </label>
                </div>
            `);
        });
      } else {
        console.log("No .option found inside .icon_content_c2 — skipping clone.");
      }
    }


   // Close embroidery modal when clicking on certain elements
   $(document).on("click", function(e) {
      if ($(e.target).hasClass("close") || $(e.target).hasClass("cross_mp") || $(e.target).hasClass("text_mp")) {
         $("#embroideryModal").css("display", "none");
         $('.reset_btn_div_inside').trigger('click');
        
         $(".textembro-c3").hide();
         $(".textembro-c2").hide();
          $(".textembro-c1").show();
          $(".btn-toggle").removeClass("currentbtn");
          $("#toggleDiv1").addClass("currentbtn");
         // $(".embrodary_rest_confrom").show();
         // $(".inner_embro .btn-toggle").show();
      }
   });

   // Monitor product form submission button state
   var $targetButton = $(".product__info-wrapper .form .product-form__submit");
   var $embroideryBtn = $("#embroideryBtn");

   if ($targetButton.length && $embroideryBtn.length) {
      function updateButtonState() {
         $embroideryBtn.prop("disabled", $targetButton.is(":disabled"));
      }

      updateButtonState(); // Run once on page load

      // Observe changes in the "disabled" attribute of the target button
      var observer = new MutationObserver(function() {
         updateButtonState();
      });

      observer.observe($targetButton[0], {
         attributes: true,
         attributeFilter: ['disabled']
      });
   } else {
      console.log("Target button or embroidery button not found.");
   }

   // Toggle content visibility
   $("#toggleDiv1").on("click", function() {

     $(".btn-toggle").removeClass("currentbtn");
      $(this).addClass("currentbtn");

     
      let $content = $("#content1");
      let $allcontent = $(".content_div")
      let $toggleDivs = $(".btn-toggle");
      let $embrRestbox = $(".embrodary_rest_confrom");

      if ($content.length) {
         $allcontent.removeClass("active").hide();
         $content.addClass("active").show();
      }

      if ($embrRestbox.length) {
         $embrRestbox.hide();
      }

      // $toggleDivs.hide();
   });

   $("#toggleDiv2").on("click", function() {

      $(".btn-toggle").removeClass("currentbtn");
      $(this).addClass("currentbtn");
     
      let $content = $("#content2");
     let $allcontent = $(".content_div")
      let $toggleDivs = $(".btn-toggle");
      let $embrRestbox = $(".embrodary_rest_confrom");

      if ($content.length) {
         $allcontent.removeClass("active").hide();
         $content.addClass("active").show();
      }

      if ($embrRestbox.length) {
         $embrRestbox.hide();
      }

      // $toggleDivs.hide();
   });

   let ranCurrencyPlacement = false;

   $("#toggleDiv3").on("click", function() {
    $('#content3').removeClass('is-uploading');

     if (Shopify.currency.active !== 'GB' && !ranCurrencyPlacement) {
        ranCurrencyPlacement = true;
        if( isPants ){
            // $('#logo-placement').prop('selectedIndex', 5).trigger('change');
            $('input[name="placement-radio-logo"][value=""]').prop('checked', true).trigger('change');
            $('input[name="placement-radio-logo"][value="left-thigh-as-worn"]').prop('checked', true).trigger('change');
        } else {
            // $('#logo-placement').prop('selectedIndex', 3).trigger('change');
            $('input[name="placement-radio-logo"][value=""]').prop('checked', true).trigger('change');
            $('input[name="placement-radio-logo"][value="left-chest-as-worn"]').prop('checked', true).trigger('change');
        }
     }

     $(".btn-toggle").removeClass("currentbtn");
      $(this).addClass("currentbtn");
     
      let $content = $("#content3");
      let $allcontent = $(".content_div")
      let $toggleDivs = $(".btn-toggle");
     
      let $embrRestbox = $(".embrodary_rest_confrom");
     
      if ($content.length) {
         $allcontent.removeClass("active").hide();
         $content.addClass("active").show();
      }

      if ($embrRestbox.length) {
         $embrRestbox.hide();
      }

      // $toggleDivs.hide();
   });

   $('#populateFieldsBtn').on('click', function() {
     $('form .product-form__buttons button').trigger('click');
     $('#embroideryModal').hide();
     // $('form .product-form__buttons button').attr('style', 'display: none !important');

     // setTimeout(function() {
     //    $('form .product-form__buttons button').removeAttr('style');
     // }, 2000);
   })
  
   // Shopify product form submission handling
   $("#custom-product-form").on("submit", async function(event) {
      event.preventDefault();

      // let $submitButton = $(this).find('[type="submit"]');
      // $submitButton.prop("disabled", true);

      // let formData = new FormData(this);

      // try {
      //    let mainProductResponse = await fetch("https://skrubz-com.myshopify.com/cart/add.js", {
      //       method: "POST",
      //       body: formData
      //    });

      //    let mainProduct = await mainProductResponse.json();
      //    console.log("Main product added:", mainProduct);

      //    if (!mainProduct || !mainProduct.id) {
      //       console.error("Main product not added successfully.");
      //       $submitButton.prop("disabled", false);
      //       return;
      //    }

      //    // Function to add extra product with delay
      //    let addExtraProduct = async (variantId, properties) => {
      //       await new Promise(resolve => setTimeout(resolve, 500)); // Small delay for Shopify

      //       let response = await fetch("https://skrubz-com.myshopify.com/cart/add.js", {
      //          method: "POST",
      //          headers: {
      //             "Content-Type": "application/json"
      //          },
      //          body: JSON.stringify({
      //             id: variantId,
      //             quantity: 1,
      //             properties: properties
      //          })
      //       });

      //       let data = await response.json();
      //       console.log("Extra product added:", data);
      //       return data;
      //    };



      //     // ***************setup 1 extra product*****************
        
      //    // Sequentially process extra product additions
      //    if ($("#custom_text").val().trim() !== "") {
      //       await addExtraProduct("46157310197926", {
      //          "Linked to": mainProduct.id,
      //          "Line 1": $("#custom_text").val()
      //       });
      //    }

      //    if ($("#custom_text_2").val().trim() !== "") {
      //       await addExtraProduct("46157310230694", {
      //          "Linked to": mainProduct.id,
      //          "Line 2": $("#custom_text_2").val()
      //       });
      //    }
      //    if ($("#custom_text_3").val().trim() !== "") {
      //       await addExtraProduct("46157310263462", {
      //          "Linked to": mainProduct.id,
      //          "Line 3": $("#custom_text_3").val()
      //       });
      //    }

      //    if ($("#custom_text").val().trim() !== "") {

      //       var placement = $("#name-placement").val(); // Get selected value
      //       if (placement !== "") {
      //          await addExtraProduct("46160583131302", {
      //             "Linked to": mainProduct.id,
      //             "Placement": placement
      //          });
      //       }
      //    }


      //   // ***************setup 2 extra product*****************
        
      //    var selectedImage = $("input[name='properties[Icons]']:checked").val();


      //    // Ensure `selectedImage` is not undefined
      //    if (typeof selectedImage !== "undefined" && selectedImage !== "") {
      //       var shortnameValue = $("#shortname").val().trim();
      //       var varitoin_id = parseFloat($(".fixrdo:checked").attr("data-variant"));
            
      //       if (shortnameValue === "") {
            
      //          await addExtraProduct(varitoin_id, {
      //             "Linked to": mainProduct.id,
      //             "Selected Icon": selectedImage
      //          });

              
      //       } else {
           

      //          await addExtraProduct( varitoin_id , {
      //             "Linked to": mainProduct.id,
      //             "Selected Icon": selectedImage,
      //             "Optional Name": shortnameValue
      //          });
      //       }
      //    }


      //   // ***************setup 3 extra product*****************

      //   // customer fixed  
      //   if (typeof isCustomerLoggedIn !== "undefined" && isCustomerLoggedIn  !== false ) {

      //     if ($("#logo-placement").val().trim() !== "") {

            
      //        var passlogoImage =  $("input.fix_past:checked").val();
            
            
      //       let customImage = document.getElementById('logo_custom').files[0];
      //           if (customImage) {
      //               await addExtraProduct("46166686466214", {
      //                   "Linked to": mainProduct.id,
      //                   "Custom logo": customImage
      //                });
      //              await addExtraProduct("46166686531750", {
      //                "Linked to": mainProduct.id,
      //                "Placement logo": $("#logo-placement").val()
      //             });
      //           }
                
      //           else{

      //              await addExtraProduct("46166686531750", {
      //                "Linked to": mainProduct.id,
      //                "Placement logo": $("#logo-placement").val(),
      //                "Past Logo" : passlogoImage
      //             });

                  
      //           }


      //   }


        
      //   // customer fixed  
      //   }
        

      //    $submitButton.prop("disabled", false);
      //    console.log("All products added successfully!");
      //    window.location.href = '/cart';

      // } catch (error) {
      //    console.error("Error adding products:", error);
      //    $submitButton.prop("disabled", false);
      // }
   });

   let embroideryData = {
        textEmbroideryData: {
            customText: "",
            customText2: "",
            customText3: "",
            namePlacement: "",
        },
        iconEmbroideryData: {
            iconSelection: "",
            shortname: "",
        },
        logoEmbroideryData: {
            logoPlacement: "",
            customLogo: "",
            pastLogo: "",
        }
    };

    // Store Text Embroidery Section Data
    function storeTextEmbroideryData() {
        embroideryData.textEmbroideryData.customText = $('#custom_text').val();
        embroideryData.textEmbroideryData.customText2 = $('#custom_text_2').val();
        embroideryData.textEmbroideryData.customText3 = $('#custom_text_3').val();
        embroideryData.textEmbroideryData.namePlacement = $('#name-placement').val();
    }
    
    // Store Icon Embroidery Section Data
    function storeIconEmbroideryData() {
        embroideryData.iconEmbroideryData.iconSelection = $('input[name="properties[Icons]"]:checked').val();
        embroideryData.iconEmbroideryData.shortname = $('#shortname').val();
    }
    
    // Store Logo Embroidery Section Data
    function storeLogoEmbroideryData() {
        embroideryData.logoEmbroideryData.logoPlacement = $('#logo-placement').val();
        embroideryData.logoEmbroideryData.customLogo = $('#logo_custom').val();
        embroideryData.logoEmbroideryData.pastLogo = $("input.fix_past:checked").val();
    }

    // Load Text Embroidery Section Data
    function loadTextEmbroideryData() {
        $('#custom_text').val(embroideryData.textEmbroideryData.customText).trigger('input');
        $('#custom_text_2').val(embroideryData.textEmbroideryData.customText2).trigger('input');
        $('#custom_text_3').val(embroideryData.textEmbroideryData.customText3).trigger('input');
        $('#name-placement').val(embroideryData.textEmbroideryData.namePlacement).trigger('change');

        $(".confirm_btn_div_inside.confirm-c1").trigger('click');
        $('#custom_text').css("border", "");
    }
    
    // Load Icon Embroidery Section Data
    function loadIconEmbroideryData() {
        // Restore icon selection and trigger the change event
        var correct_icon = $('#embroideryModal .modal-body .options-container .icon_content_c2 .option input[value="' + embroideryData.iconEmbroideryData.iconSelection + '"]');
            // .trigger('click change'); // Trigger change event for the icon selection
        correct_icon.trigger('click');
        correct_icon.trigger('change');
    
        // Restore shortname and trigger the input event
        $('#shortname').val(embroideryData.iconEmbroideryData.shortname).trigger('input'); // Trigger input event

        $('.confirm-c2').trigger('click');
    }
    
    // Load Logo Embroidery Section Data
    function loadLogoEmbroideryData() {
        $('#logo-placement').val(embroideryData.logoEmbroideryData.logoPlacement).trigger('change');
        // $('#logo_custom').val(embroideryData.logoEmbroideryData.customLogo).trigger('input');
        $('input[name="properties[Past Logo]"][value="' + embroideryData.logoEmbroideryData.pastLogo + '"]')
            .prop('checked', true)
            .trigger('click');
    }



  
   // confirm buton
   $(".confirm_btn_div_inside.confirm-c1").on("click", function() {
      var customText = $("#custom_text");
      var hasError = false;

      // Check if input fields are empty
      if (customText.val().trim() === "") {
         customText.css("border", "1px solid red");
         $(".btn-toggle .price_text_1").text("");
         toggleAddToCartButton();
         hasError = true;
      } else {
         customText.css("border", "");

         if ( $('#name-placement').val() == '' ){
           hasError = true;
           $('#name-placement').css("border", "1px solid red");
         } else {
           $('#name-placement').css("border", "");
         }
      }

      var text1 = $('#custom_text').val();
      var text2 = $('#custom_text_2').val();
      var text3 = $('#custom_text_3').val();

      if( text1.trim() == '' ) {
        $('input[name^="Line 1"], input[name^="Line 2"], input[name^="Line 3"]').val('');
        $('select[name^="Name placement"]').val('');
        if($('#name-placement').val() !== '') {
            $('#name-placement').val('').trigger('change');
        }
        return false;
      }

    //   $('input[name="ymq[Line 1]"]').val(text1);
    //   $('input[name="ymq[Line 2]"]').val(text2);
    //   $('input[name="ymq[Line 3]"]').val(text3);
      $('input[name^="Line 1"]').val(text1);
      $('input[name^="Line 2"]').val(text2);
      $('input[name^="Line 3"]').val(text3);

      let name_placement = $('#name-placement option:selected').text();
    //   console.log(name_placement);
    //   $('select[name="ymq[Name placement]"]').val(name_placement);
      $('select[name^="Name placement"]').val(name_placement);

      if (!hasError) {
         storeTextEmbroideryData();
        //  $(".textembro-c1").hide();
         $(".embrodary_rest_confrom").show();
         $(".inner_embro .btn-toggle").show();
         var gettext = $(".total_price_c1.total_active .total_price_span").text();

         if(gettext > 0) {
           $(".btn-toggle .price_text_1").text('£'+gettext);
         } else {
           $(".btn-toggle .price_text_1").text(gettext);
         }
         toggleAddToCartButton();
      }

   });

  
    // confirm buton 2
//    $(".confirm_btn_div_inside.confirm-c2").on("click", function() {
//       const selectedVal = $('input[name="properties[Icons]"]:checked').val();

//       if (selectedVal) {
//         $('.spotlight-group label').each(function () {
//           const styleAttr = $(this).attr('style') || '';
//           const urlMatch = styleAttr.match(/url\(["']?(.*?)["']?\)/);
      
//           if (urlMatch && urlMatch[1] === selectedVal) {
//             $(this).trigger('click');
//           }
//         });
//       }

//       const shortnameVal = $('#shortname').val();
     
//       storeIconEmbroideryData();
     
//     //   $('input[name="ymq[Initials (Optional)]"]').val(shortnameVal);
//       $('input[name^="Initials (Optional)"]').val(shortnameVal);
     
//       $(".textembro-c2").hide();
//       $(".embrodary_rest_confrom").show();
//       $(".inner_embro .btn-toggle").show();
//       var gettext = $(".total_price_c2.total_active .total_price_span_2").text();
     
//       if(gettext > 0) {
//         $(".btn-toggle .price_text_2").text('£'+gettext);
//       } else {
//         $(".btn-toggle .price_text_2").text(gettext);
//       }
//       toggleAddToCartButton();
//    });

    $(".confirm_btn_div_inside.confirm-c2").on("click", function () {

        // Get selected cloned icon value (image URL)
        const selectedVal = $('input[name="properties[Icons]"]:checked').val();

        if (selectedVal) {

            // Loop through original YMQ Icons radios
            $('input[name^="Icons-"]').each(function () {

            const $radio = $(this);
            const imgSrc = $radio
                .closest('.ymq-option-label')
                .find('.ymq-option-swatches-image')
                .attr('src');

            if (imgSrc && imgSrc === selectedVal) {
                // Trigger original YMQ option
                $radio.trigger('click');
                return false; // stop loop after match
            }
            });
        }

        const shortnameVal = $('#shortname').val();

        storeIconEmbroideryData();

        // Set initials dynamically
        $('input[name^="Initials (Optional)"]').val(shortnameVal);

        $(".textembro-c2").hide();
        $(".embrodary_rest_confrom").show();
        $(".inner_embro .btn-toggle").show();

        var gettext = $(".total_price_c2.total_active .total_price_span_2").text();

        if (gettext > 0) {
            $(".btn-toggle .price_text_2").text('£' + gettext);
        } else {
            $(".btn-toggle .price_text_2").text(gettext);
        }

        toggleAddToCartButton();
    });


   // confirm buton 3
    $(".confirm_btn_div_inside.confirm-c3").on("click", function() {

     // var customlogo = $("#logo_custom");
     // var customlogo = $('.ymq_upload_img_item.ymq_upload_file_item');
     var customlogo = $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-item');
     var _logoInput = document.getElementById('logo_custom');
     var hasLocalFile = _logoInput && _logoInput.files && _logoInput.files.length > 0;
     var passlogo = $("input.fix_past:checked").val();
     var currentlogo = $("input.fix_current:checked").val();
     var posplace = $("#logo-placement").val();
      
      var hasError = false;

      // Check if input fields are empty
      if ( customlogo.length == 0 && !hasLocalFile && typeof passlogo == "undefined" && typeof currentlogo == "undefined" ) {
          if($('#logo-placement').val() == ''){
            $("#logo-placement").css("border", "1px solid red");
          }
          if($('#logo-placement').val() !== '') {
            $('#logo-placement').val('').trigger('change');
          }
           $('#logo_custom').css("border", "1px solid red");
           $(".reallogo").css("border", "1px solid red");
           $(".reallogo_current").css("border", "1px solid red");
          $(".btn-toggle .price_text_3").text("");
           toggleAddToCartButton();
           hasError = true;
      } else {
          $("#logo_custom").css("border", "");
          $("#logo_custom").removeAttr("style");
          $(".reallogo").removeAttr("style");
          $(".reallogo_current").removeAttr("style");
      }

      if ( customlogo.length > 0 || hasLocalFile || typeof passlogo != "undefined"  || typeof currentlogo != "undefined") {
          if($('#logo-placement').val() == ''){
            $("#logo-placement").css("border", "1px solid red");
            hasError = true;
          } else {
            $("#logo-placement").removeAttr("style");
          }
      }
      
      if (!hasError) {
        storeLogoEmbroideryData();
        $(".textembro-c3").hide();
        $(".embrodary_rest_confrom").show();
        $(".inner_embro .btn-toggle").show();
        var gettext = $(".total_price_c3.total_active .total_price_span_3").text();
        // $(".btn-toggle .price_text_3").text('£'+gettext);
        
        if(gettext > 0) {
          $(".btn-toggle .price_text_3").text('£'+gettext);
        } else {
          $(".btn-toggle .price_text_3").text(gettext);
        }
        toggleAddToCartButton();
      }

      
   });



  
   // Remove red border on input when typing
   $("#custom_text").on("input", function() {
      $(this).css("border", "");
   });

   // back button logic
   $('.back_embro_c1').on('click', function() {
      $(".textembro-c1").hide();
      $(".embrodary_rest_confrom").show();
      $(".inner_embro .btn-toggle").show();
      loadTextEmbroideryData();
      updateTotalPrice();
      toggleAddToCartButton();
   });

   // back icon embroidery button logic
   $('.back_embro_c2').on('click', function() {
      $(".textembro-c2").hide();
      $(".embrodary_rest_confrom").show();
      $(".inner_embro .btn-toggle").show();
      loadIconEmbroideryData();
      updateTotalPrice_icons();
      toggleAddToCartButton();
   });

  $('.back_embro_c3').on('click', function() {
      $(".textembro-c3").hide();
      $(".embrodary_rest_confrom").show();
      $(".inner_embro .btn-toggle").show();
      loadLogoEmbroideryData();
      updateTotalPrice_logo();
      toggleAddToCartButton();
   });


  

   // reset form logic
   $(".reset_btn_div_inside.reset-c1").on("click", function() {
      var customText = $("#custom_text");
      var customText2 = $("#custom_text_2");
      var customText3 = $("#custom_text_3");
      customText.val("").css("border", "").trigger('input'); // Clear input and remove border
      customText2.val("").css("border", "").trigger('input'); // Clear input and remove border
      customText3.val("").css("border", "").trigger('input'); // Clear input and remove border
      $('#name-placement').css("border", "");

    //   $('input[name="ymq[Line 1]"]').val('');
    //   $('input[name="ymq[Line 2]"]').val('');
    //   $('input[name="ymq[Line 3]"]').val('');
      
      $('input[name^="Line 1"]').val('');
      $('input[name^="Line 2"]').val('');
      $('input[name^="Line 3"]').val('');

    //   $('select[name="ymq[Name placement]"]').val('');
      $('select[name^="Name placement"]').val('');

      // Reset the embroidery data object to its initial empty state
      embroideryData.textEmbroideryData = {
         customText: "",
         customText2: "",
         customText3: "",
         namePlacement: "",
      };
      
      updateTotalPrice();
      $(".btn-toggle .price_text_1").text("");
      toggleAddToCartButton();
   });

   // reset 2 form logic  
   $(".reset_btn_div_inside.reset-c2").on("click", function() {
      $(".btn-toggle .price_text_2").text("");
      $(".novalueradio").prop("checked", true).trigger("change click");
      
      $('#second_image').hide();
      $('#second_image_text').hide();
      $('#shortname').val('');
      $('#second_image_text').text('');

      // Optionally reset other data if required
      embroideryData.iconEmbroideryData = {
         iconSelection: "",
         shortname: "",
      };
     
      updateTotalPrice_icons();
      toggleAddToCartButton();

   });

   // reset 3 form logic 
   $(".reset_btn_div_inside.reset-c3").on("click", function() {
      $('#logo_custom').val(''); // Reset file input
      $('.fix_past_zero').trigger('click');
      $('#logo-placement').prop('selectedIndex', 0).trigger('change');
      $(".btn-toggle .price_text_3").text("");
       $(".total_price_span_3").text("");
      $(".total_price.total_price_c3").hide().removeClass("total_active");
      //   $('.ymq_upload_img_item_bg .ymq_upload_img_item_del.ymq_upload_file_item_del').trigger('click');
      $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-remove').trigger('click');
    //   $('input[name="ymq[Past Logo]"]').val('');
      $('input[name^="Past Logo"]').val('');
    //   $('select[name="ymq[Logo placement]"]').val('');
      $('select[name^="Logo placement"]').val('');

      embroideryData.logoEmbroideryData = {
        logoPlacement: "",
        customLogo: "",
        pastLogo: "",
      };

      toggleAddToCartButton();

   });

   function updateTotalPrice() {
      var total = 0;

      // Loop through each input field
      $("#custom_text, #custom_text_2, #custom_text_3").each(function() {
         var inputVal = $(this).val().trim();
         var price = parseFloat($(this).prev("label").attr("data-price")) || 0;

         if (inputVal !== "") {
            total += price;
         }
      });

    //   console.log(localization_currency);
      if ( localization_currency == 'GB' ) {
          var taxPrice = total * 1.2;
          var tax = taxPrice - total;
      }

      // Update the total price span
      // $(".total_price_span").text(total.toFixed(2));
      if ( localization_currency == 'GB' ) {
        $(".total_price_span").text(taxPrice.toFixed(2));
        $(".tax").text(tax.toFixed(2));
      } else {
        $(".total_price_span").text(total.toFixed(2));
      }

      // Show or hide the total price div
      if (total > 0) {
         $(".total_price.total_price_c1").show().addClass("total_active");
      } else {
         $(".total_price.total_price_c1").hide().removeClass("total_active");
      }
   }

   // Update total price when typing
   $("#custom_text, #custom_text_2, #custom_text_3").on("input", function() {
      updateTotalPrice();
   });

   function updateTotalPrice_icons() {
      var total = 0;

      if ($(".novalueradio:checked").length > 0) {
         $(".total_price.total_price_c2").hide().removeClass("total_active");
         $(".total_price_span_2").text(""); // Clear price
         $(".price_text_2").text("");
         $("#shortname").prop("disabled", true);
         $("#shortname").val("");
         toggleAddToCartButton();
         return; // Stop further calculations
      }

      // Loop through each checked radio button
      $(".fixrdo:checked").each(function() {
         var price = parseFloat($(this).closest(".pricelabel").attr("data-price")) || 0;
         total += price;
      });
      
      if ( localization_currency == 'GB' ) {
        var taxPrice2 = total * 1.2;
        var tax2 = taxPrice2 - total;
      }

      $("#shortname").prop("disabled", false);
      // Update the total price span
    //   $(".total_price_span_2").text(total.toFixed(2));
    if ( localization_currency == 'GB' ) {
      $(".total_price_span_2").text(taxPrice2.toFixed(2));
      $(".tax_2").text(tax2.toFixed(2));
    } else {
      $(".total_price_span_2").text(total.toFixed(2));
    }

      // Show or hide the total price div
      if (total > 0) {
         $(".total_price.total_price_c2").show().addClass("total_active");
      } else {
         $(".total_price.total_price_c2").hide().removeClass("total_active");
      }
   }



    function updateTotalPrice_logo() {
        var total = 0;
        var logo_custom =  $("#logo_custom").val();
        // var logo_custom =  $(".ymq_upload_img_item.ymq_upload_file_item");
           
         if (logo_custom.length > 0) {
           // Loop through each checked radio button inside `.title_csutomlogo`
           // $(".title_csutomlogo").each(function() {
           //     var price = parseFloat($(this).attr("data-price")) || 0;
           //     total += price;
           // });
           var price = parseFloat($('div.title_csutomlogo').data('price')) || 0;
           total += price;
         }

        if( $('#logo-placement').val() != '' ) {
          // Get selected logo placement price
          var logoPlacementPrice = parseFloat($(".logoplace").attr("data-price")) || 0;
        } else {
          var logoPlacementPrice = 0;
        }
        total+= logoPlacementPrice;

         if ( localization_currency == 'GB' ) {
            // console.log('is gbp');
            var taxPrice3 = total * 1.2;
            var tax3 = taxPrice3 - total;
         }
      
    
        // Update the total price span
        // $(".total_price_span_3").text(total.toFixed(2)); // Ensure 2 decimal places
        if ( localization_currency == 'GB' ) {
            // console.log('is also gbp');
            $(".total_price_span_3").text(taxPrice3.toFixed(2)); // Ensure 2 decimal places
            $(".tax_3").text(tax3.toFixed(2));
        } else {
            $(".total_price_span_3").text(total.toFixed(2)); // Ensure 2 decimal places
        }
    
        // Show or hide the total price div
        if (total > 0) {
            $(".total_price.total_price_c3").show().addClass("total_active");
        } else {
            $(".total_price.total_price_c3").hide().removeClass("total_active");
        }
    }


   // Run function when a radio button is checked/changed
   $(document).on("change", ".fixrdo, .novalueradio", function() {
      updateTotalPrice_icons();
   });

   $(document).on("click", ".novalueradio", function() {
      // Check if any radio button is checked in the group
    //   var checkedRadio = $("input[name='ymq[Icons]']:checked");
      var checkedRadio = $("input[name^='Icons']:checked");
  
      // If a radio button is checked, trigger a click on its corresponding label
      if (checkedRadio.length > 0) {
          var labelId = "label[for='" + checkedRadio.attr('id') + "']"; // Find the corresponding label for the checked radio
          $(labelId).trigger("click"); // Trigger click event on the label
      }
   });

   $('#rest_btn_action').on('click', function() {
      $('.reset_btn_div_inside').trigger('click');
   });


    $('#logo_custom').on('change', function() {
        let file = this.files[0];
        if (file && file.type.startsWith('image/')) {
          $("#logo_custom").removeAttr("style");
           $(".reallogo").removeAttr("style");
           $(".reallogo_current").removeAttr("style");
           updateTotalPrice_logo();
        }else{
          $(".total_price_span_3").text("");
          $(".total_price.total_price_c3").hide().removeClass("total_active");
       }
       $(".fix_past").prop("checked", false);
    });



    $(document).on("click", ".fix_past", function() {
        if( $('.ymq_upload_img_item.ymq_upload_file_item').length > 0 ) {
          if (confirm("Are you sure you want to change the logo or remove it?")) {
            
          } else {
              return false;
          }
        }
      
        $("#logo_custom").val(""); // Clear file input when radio is clicked
        // $('.ymq_upload_img_item_bg .ymq_upload_img_item_del.ymq_upload_file_item_del').trigger('click');
        $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-remove').trigger('click');
        // $('input[name="ymq[Past Logo]"]').val($(this).val());
        $('input[name^="Past Logo"]').val($(this).val());
        // $('input[name="ymq[Current Logo]"]').val('');
        $('input[name^="Current Logo"]').val('');
        $('input[name="properties[Current Logo]"]').prop('checked', false);
        $('#selectedImage').attr('src', $(this).val());
        updateTotalPrice_logo();

        if ($(window).width() < 767) {
            if( isCap ) {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '18.95312vw',
                     'left': '11vw',
                     'bottom': '58.5vw',
                });
            } else {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '8.953125vw',
                    // 'left': '27.994791666666668vw',
                    // 'top': '21.044270833333334vw',
                });
            }

            if ($('#logo-placement').val() !== '') {
                $('#selectedImage').show();
            } else {
                $('#selectedImage').hide();
            }
        } else {
            if( isCap ) {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '6.9531vw',
                    // 'left': '10.67vw',
                    // 'bottom': '28.5vw',
                });
            } else {
                // if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1) {
                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    $('#selectedImage').css({
                        // 'height': '1.5312vw',
                        'width': '1.5312vw',
                        // 'left': '27.994791666666668vw',
                        // 'top': '21.044270833333334vw',
                    });
                } else {
                    $('#selectedImage').css({
                        // 'height': '1.35312vw',
                        'width': '1.85312vw',
                        // 'left': '27.994791666666668vw',
                        // 'top': '21.044270833333334vw',
                    });
                }
            }

            if ($('#logo-placement').val() !== '') {
                $('#selectedImage').show();
            } else {
                $('#selectedImage').hide();
            }
        }
        $("#logo_custom").css("border", "");
        $("#logo_custom").removeAttr("style");
        $(".reallogo").removeAttr("style");
    });

    $(document).on("click", ".fix_current", function() {
        if( $('.ymq_upload_img_item.ymq_upload_file_item').length > 0 ) {
          if (confirm("Are you sure you want to change the logo or remove it?")) {
            
          } else {
              return false;
          }
        }
      
        $("#logo_custom").val(""); // Clear file input when radio is clicked
        // $('.ymq_upload_img_item_bg .ymq_upload_img_item_del.ymq_upload_file_item_del').trigger('click');
        $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-remove').trigger('click');
        // $('input[name="ymq[Past Logo]"]').val('');
        $('input[name^="Past Logo"]').val('');
        // $('.fix_past_zero').trigger('click');
        $('input[name="properties[Past Logo]"]').prop('checked', false);
        // $('input[name="ymq[Current Logo]"]').val($(this).val());
        $('input[name^="Current Logo"]').val($(this).val());
        $('#selectedImage').attr('src', $(this).val());
        updateTotalPrice_logo();

        if ($(window).width() < 767) {
            if( isCap ) {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '24.95312vw',
                    // 'left': '11vw',
                    // 'bottom': '58.5vw',
                });
            } else {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '8.95312vw',
                    // 'left': '27.994791666666668vw',
                    // 'top': '21.044270833333334vw',
                });
            }

            if ($('#logo-placement').val() !== '') {
                $('#selectedImage').show();
            } else {
                $('#selectedImage').hide();
            }
        } else {
            if( isCap ) {
                $('#selectedImage').css({
                    // 'height': '2.953125vw',
                    'width': '6.9531vw',
                    // 'left': '10.67vw',
                    // 'bottom': '28.5vw',
                });
            } else {
                // if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1) {
                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    $('#selectedImage').css({
                        // 'height': '1.5312vw',
                        'width': '1.5312vw',
                        // 'left': '27.994791666666668vw',
                        // 'top': '21.044270833333334vw',
                    });
                } else {
                    $('#selectedImage').css({
                        // 'height': '1.35312vw',
                        'width': '1.85312vw',
                        // 'left': '27.994791666666668vw',
                        // 'top': '21.044270833333334vw',
                    });
                }
            }

            if ($('#logo-placement').val() !== '') {
                $('#selectedImage').show();
            } else {
                $('#selectedImage').hide();
            }
        }
        $("#logo_custom").css("border", "");
        $("#logo_custom").removeAttr("style");
        $(".reallogo").removeAttr("style");
    });

    $('.fix_past_zero').on('click', function() {
        if( $('.ymq_upload_img_item.ymq_upload_file_item').length > 0 ) {
          if (confirm("Are you sure you want to change the logo or remove it?")) {
            
          } else {
              return false;
          }
        }
      
        // $('.ymq_upload_img_item_bg .ymq_upload_img_item_del.ymq_upload_file_item_del').trigger('click');
        $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-remove').trigger('click');
        // $('input[name="ymq[Past Logo]"]').val('');  
        $('input[name^="Past Logo"]').val('');  
        // $('input[name="ymq[Current Logo]"]').val('');
        $('input[name^="Current Logo"]').val('');
        $('input[name="properties[Current Logo]"]').prop('checked', false);
        $("#logo_custom").val('');
        $('#selectedImage').attr('src', '');        
        $('#selectedImage').css('display', 'none');      
        $("#logo_custom").css("border", "");
        $("#logo_custom").removeAttr("style");
        $(".reallogo").removeAttr("style");
    });


 
  // $("#logo-placement").val("right-chest-as-worn-3");
  //  updateTotalPrice_logo();

    // Update when logo placement is changed
    $("#logo-placement").on("change", function() {
        updateTotalPrice_logo();  
        $("#logo_custom").css("border", "");
        $("#logo_custom").removeAttr("style");
        $(".reallogo").removeAttr("style");
        $(".reallogo_current").removeAttr("style");
        $("#logo-placement").removeAttr("style");
    });
        // New js for left side of embroidery

        $('#custom_text').on('input', function(e) {
            var text = $(this).val();

            if (text.trim() == '') {
                $('#custom_text_2').attr('disabled', 'disabled');
                $('#custom_text_2').val('').trigger('input');
                $('#custom_text_3').attr('disabled', 'disabled');
                $('#custom_text_3').val('').trigger('input');
            } else {
                $('#custom_text_2').removeAttr('disabled');
                $('#custom_text_3').removeAttr('disabled');
            }
            
            $('#text-overlay p#line1').text(text);

            if ($('#custom_text').val() == '' && $('#custom_text_2').val() == '' && $('#custom_text_3').val() == '') {
                $('#text-overlay').hide();
            }

            if($('#custom_text').val() != '' || $('#custom_text_2').val() != '' || $('#custom_text_3').val() != '') {
              $('#text-overlay').show();
            }

            if ($('#name-placement').val() == '') {
                $('#text-overlay').hide();
            }
        });

        $('#custom_text, #custom_text_2, #custom_text_3').on('keypress input keydown', function(event) {
            var textLength = $(this).val().length;
            var warningId = 'char-warning-' + $(this).attr('id');

            if ($(window).width() < 767) {
                if( isCap ) {
                    $('#text-overlay').css('top', "54vw");
                    $('#text-overlay').css('right', "10vw");
                    $('#text-overlay').css('transform', "rotate(22deg)");
                    $('#line1').css('font', "3.55vw / 100% Assistant, Arial, Helvetica, sans-serif");
                    $('#selectedImage').css('left', "8.67vw !important");
                    $('#selectedImage').css('bottom', "28vw !important");
                    $('#selectedImage').css('width', "8.85312vw !important");
                    $('#selectedImage').css('transform', "rotate(14deg)");
                }
            } else {
                if( isCap ) {
                    $('#text-overlay').css('top', "26vw");
                    $('#text-overlay').css('right', "10vw");
                    $('#text-overlay').css('transform', "rotate(22deg)");
                    $('#line1').css('font', "1.55vw / 100% Assistant, Arial, Helvetica, sans-serif");
                    $('#selectedImage').css('left', "8.67vw !important");
                    $('#selectedImage').css('bottom', "28vw !important");
                    $('#selectedImage').css('width', "8.85312vw !important");
                    $('#selectedImage').css('transform', "rotate(14deg)");
                }
            }

            // Check if the character limit has been reached
            if (textLength >= 30) {
                if (!$('#' + warningId).length) { // Check if the warning message doesn't already exist
                    $(this).after('<p id="' + warningId + '" style="color: red; margin:0; padding:0;">Character limit reached.</p>');

                    setTimeout(function() {
                        $('#' + warningId).remove();
                    }, 2000);
                }
            }
            var text = $(this).val();
            var spaceCount = (text.match(/ /g) || []).length;

            // Prevent adding more spaces if there are already two
            if (event.which === 32 && spaceCount >= 4) {
                event.preventDefault();
            }
        });

        $('#custom_text, #custom_text_2, #custom_text_3').on('input', function() {
            var text = $(this).val();
            var spaceCount = (text.match(/ /g) || []).length;
        
            // If more than 2 spaces, remove excess spaces
            if (spaceCount > 4) {
                $(this).val(text.replace(/\s{3,}/g, ' ').trim());
            }
        });

        $('#name-placement').change(function() {
            var productTitle = $('.product__title h1').text().toLowerCase();
            if ($(window).width() < 767) {
                var selectedValue = $(this).val();

                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    if (selectedValue == 'left-thigh-as-worn') {
                        $('#text-overlay').show();
                        $('#text-overlay').css('left', '56.378vw');
                        $('#text-overlay').css('right', 'unset');
                        $('#text-overlay').css('top', '26.5vw');
                        // $('#text-overlay').css('width', 'auto');
                    } else if (selectedValue == 'right-thigh-as-worn') {
                        $('#text-overlay').show();
                        $('#text-overlay').css('right', 'unset');
                        $('#text-overlay').css('left', '32vw');
                        $('#text-overlay').css('top', '26.5vw');
                        // $('#text-overlay').css('width', 'auto');
                        // addPrice(rawPrice);
                    } else {
                        $('#text-overlay').hide();
                    }
                } else if ($('.product__title h1').text().toLowerCase().indexOf('bag') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('pants') === -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    $('#text-overlay').show();
                    $('#text-overlay').css('left', '50%');
                    $('#text-overlay').css('top', '68%');
                    $('#text-overlay').css('transform', 'translate(-50%, -50%)');
                    $('#text-overlay p').css('font-size', '3.545vw');
                    $('#text-overlay p').css('color', '#000');
                    $('#text-overlay p').css('font-weight', '700');
                    
                } else {

                    
                    if (selectedValue == 'right-chest-as-worn') {
                        $('#text-overlay').show();
                        // $('#text-overlay').css('width', 'auto');
                        $('#text-overlay').css('left', '30.395vw');
                        $('#text-overlay').css('right', 'unset');
                        $('#text-overlay').css('top', '32.135vw');
                    } else if (selectedValue == 'left-chest-as-worn') {
                        $('#text-overlay').show();
                        // $('#text-overlay').css('width', 'auto');
                        if(productTitle.indexOf('v neck') !== -1){
                            $('#text-overlay').css('right', 'unset');
                            $('#text-overlay').css('left', '54.195vw');
                            $('#text-overlay').css('top', '32.135vw');
                            
                        }else{
                            $('#text-overlay').css('right', 'unset');
                            $('#text-overlay').css('left', '53.595vw');
                            $('#text-overlay').css('top', '32.135vw');
                            
                        }
                    } else {
                        $('#text-overlay').hide();
                    }
                }
            } else {
                var selectedValue = $(this).val();

                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    if (selectedValue == 'left-thigh-as-worn') {
                        $('#text-overlay').show();
                        $('#text-overlay').css('left', 'unset');
                        $('#text-overlay').css('right', '17.1vw');
                        $('#text-overlay').css('top', '15vw');
                    } else if (selectedValue == 'right-thigh-as-worn') {
                        $('#text-overlay').show();
                        $('#text-overlay').css('right', 'unset');
                        $('#text-overlay').css('left', '17.1vw');
                        $('#text-overlay').css('top', '15vw');
                    } else {
                        $('#text-overlay').hide();
                    }
                } else if ($('.product__title h1').text().toLowerCase().indexOf('bag') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('pants') === -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    $('#text-overlay').show();
                    $('#text-overlay').css('left', '50%');
                    $('#text-overlay').css('top', '66%');
                    $('#text-overlay').css('transform', 'translate(-50%, -50%)');
                    $('#text-overlay p').css('font-size', '1.588vw');
                    $('#text-overlay p').css('color', '#000');
                    $('#text-overlay p').css('font-weight', '700');
                } else {
                    if (selectedValue == 'left-chest-as-worn') {
                        $('#text-overlay').show();
                        if(productTitle.indexOf('v neck') !== -1){
                            $('#text-overlay').css('left', '26.7vw');
                            $('#text-overlay').css('right', 'unset');
                        }else{
                            $('#text-overlay').css('left', '27.67vw');
                            $('#text-overlay').css('right', 'unset');
                        }
                    } else if (selectedValue == 'right-chest-as-worn') {
                        $('#text-overlay').show();
                        $('#text-overlay').css('left', '17.7vw');
                        $('#text-overlay').css('right', 'unset');
                    } else {
                        $('#text-overlay').hide();
                    }
                }
            }
            $('#name-placement').css("border", "");
        });

        $('#custom_text_2').on('input', function() {
            var text = $(this).val();
            $('#text-overlay p#line2').text(text);

            if ($('#custom_text').val() == '' && $('#custom_text_2').val() == '' && $('#custom_text_3').val() == '') {
                $('#text-overlay').hide();
            }

            if($('#custom_text').val() != '' || $('#custom_text_2').val() != '' || $('#custom_text_3').val() != '') {
              $('#text-overlay').show();
            }

            if ($('#name-placement').val() == '') {
                $('#text-overlay').hide();
            }
        });

        $('#custom_text_3').on('input', function() {
            var text = $(this).val();
            $('#text-overlay p#line3').text(text);

            if ($('#custom_text').val() == '' && $('#custom_text_2').val() == '' && $('#custom_text_3').val() == '') {
                $('#text-overlay').hide();
            }

            if($('#custom_text').val() != '' || $('#custom_text_2').val() != '' || $('#custom_text_3').val() != '') {
              $('#text-overlay').show();
            }

            if ($('#name-placement').val() == '') {
                $('#text-overlay').hide();
            }
        });

        $(document).on('click', '#embroideryModal .modal-body .options-container .icon_content_c2 .option input', function(e) {
            var dataval = $(this).val();
            if(dataval !== ''){
                $('#second_image').show();
                $('#second_image_text').show();
              
                if ($(window).width() < 767) {
                    $('#second_image').css('width', '4.55312vw');

                    if($('.product__title h1').text().toLowerCase().indexOf('collar scrub') != -1){
                        $('#icon-text').css('right', 'calc(0.000vw + 14.744vw)');
                        $('#icon-text').css('top', 'calc(0.000vw + 28.988vw)');
                    }else{
                        $('#icon-text').css('right', 'calc(0.000vw + 6.744vw)');
                        $('#icon-text').css('top', 'calc(0.000vw + 42.488vw)');
                         
                    }

                } else{
                    $('#second_image').css('width', '1.7312vw');
                    
                    if($('.product__title h1').text().toLowerCase().indexOf('collar scrub') != -1){
                        $('#icon-text').css('right', 'calc(0.000vw + 10.38vw)');
                        $('#icon-text').css('top', 'calc(0.000vw + 15.053vw)');
                    }else{
                        $('#icon-text').css('right', 'calc(0.000vw + 8.073vw)');
                        $('#icon-text').css('top', 'calc(0.000vw + 18.490vw)');
                    }
                }
                $('#second_image').attr('src', dataval);
            }else{
                $('#second_image').hide();
                $('#second_image_text').hide();
                $('#shortname').val('');
                $('#second_image_text').text('');
            }
        });

        $('#shortname').on('input', function(e) {
            var text = $(this).val();
            $('#second_image_text').text(text);
        });

        $('#logo_custom').on('click', function(event) {
            // On bulk order page YMQ's upload widget doesn't render — allow native picker
            if ($('.ymq-options-box .ymq-option-upload-wrapper').length === 0) {
                return; // native file picker opens normally
            }
            if( $('.ymq-options-box .ymq-option-preview-item').length > 0 ) {

                // if ($('input[name="ymq[Logo]"]').val() !== '') {
                if (confirm("Are you sure you want to change the logo or remove it?")) {
                    event.preventDefault();
                    $('#logo_custom').val('').trigger('change');
                    $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-preview-item .ymq-option-preview-remove').trigger('click');
                    $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-upload-input').trigger('click');
                    // return true;
                } else {
                    return false;
                }
            } else {
              event.preventDefault();
              $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-upload-input').trigger('click');
              // $(this).prop('files', $('.ymq_upload_new_box .ymq_upload_img_view label.ymq_upload_new input.ymq-options-file-input').files);
            }
        });

        $('.ymq-options-box .ymq-option-upload-wrapper .ymq-option-upload-input').off('change').on('change', function(e) {
            console.log('checking if it works');

            const ymqWrapper = document.querySelector('.ymq-options-box .ymq-option-upload-wrapper');
            if (!ymqWrapper) {
                console.warn('ymq wrapper not found');
                return;
            }

            // ── Kill any previous observer ────────────────────────────────────
            if (ymqUploadObserver) {
                ymqUploadObserver.disconnect();
                ymqUploadObserver = null;
            }

            // ── Show blur on content3 while uploading ─────────────────────────
            $('#content3').addClass('is-uploading');

            ymqUploadObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {

                    // ── Watch for ymq-option-loading class being added ────────
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        const uploadBox = ymqWrapper.querySelector('.ymq-option-upload-box');
                        if (!uploadBox) return;

                        if (uploadBox.classList.contains('ymq-option-loading')) {
                            $('#content3').addClass('is-uploading');
                            return;
                        }

                        if (!uploadBox.classList.contains('ymq-option-file-limit')) return;

                        console.log('ymq-option-file-limit detected — upload complete');

                        const previewImg = ymqWrapper.querySelector('.ymq-option-preview-item .ymq-option-preview-img');
                        const filenameEl = ymqWrapper.querySelector('.ymq-option-preview-item .ymq-option-preview-filename');

                        if (!previewImg) return;

                        const blobUrl  = previewImg.getAttribute('src');
                        const filename = filenameEl ? filenameEl.textContent.trim() : 'logo.png';

                        if (!blobUrl || !blobUrl.startsWith('blob:')) return;

                        console.log('blob URL:', blobUrl);
                        console.log('filename:', filename);

                        ymqUploadObserver.disconnect();
                        ymqUploadObserver = null;

                        fetch(blobUrl)
                            .then(res => res.blob())
                            .then(blob => {
                                const mimeType = blob.type || 'image/png';
                                const file     = new File([blob], filename, { type: mimeType });
                                const dt       = new DataTransfer();
                                dt.items.add(file);
                                document.getElementById('logo_custom').files = dt.files;
                                console.log('logo_custom files assigned:', document.getElementById('logo_custom').files[0].name);
                                $('#selectedImage').attr('src', blobUrl);
                                $('#logo_custom').trigger('change');
                            })
                            .catch(err => console.error('Failed to fetch blob:', err))
                            .finally(() => {
                                $('#content3').removeClass('is-uploading');
                            });

                        return;
                    }

                    // ── Fallback — watch for preview item added to DOM ────────
                    mutation.addedNodes.forEach(function(node) {
                        if (!node.querySelector) return;

                        const uploadBox = ymqWrapper.querySelector('.ymq-option-upload-box');
                        if (!uploadBox || !uploadBox.classList.contains('ymq-option-file-limit')) return;

                        const previewImg = node.classList && node.classList.contains('ymq-option-preview-item')
                            ? node.querySelector('.ymq-option-preview-img')
                            : node.querySelector('.ymq-option-preview-item .ymq-option-preview-img');

                        if (!previewImg) return;

                        const blobUrl    = previewImg.getAttribute('src');
                        const filenameEl = node.classList && node.classList.contains('ymq-option-preview-item')
                            ? node.querySelector('.ymq-option-preview-filename')
                            : node.querySelector('.ymq-option-preview-filename');
                        const filename   = filenameEl ? filenameEl.textContent.trim() : 'logo.png';

                        if (!blobUrl || !blobUrl.startsWith('blob:')) return;

                        console.log('fallback — blob URL:', blobUrl);

                        ymqUploadObserver.disconnect();
                        ymqUploadObserver = null;

                        fetch(blobUrl)
                            .then(res => res.blob())
                            .then(blob => {
                                const mimeType = blob.type || 'image/png';
                                const file     = new File([blob], filename, { type: mimeType });
                                const dt       = new DataTransfer();
                                dt.items.add(file);
                                document.getElementById('logo_custom').files = dt.files;
                                console.log('logo_custom files assigned:', document.getElementById('logo_custom').files[0].name);
                                $('#logo_custom').trigger('change');
                            })
                            .catch(err => console.error('Failed to fetch blob:', err))
                            .finally(() => {
                                $('#content3').removeClass('is-uploading');
                            });
                    });
                });
            });

            ymqUploadObserver.observe(ymqWrapper, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });

            console.log('observer started — waiting for ymq-option-file-limit...');
        });
  
        $('#logo_custom').on('change', function(event) {  
            // $('input[name="ymq[Past Logo]"]').val('');
            $('input[name^="Past Logo"]').val('');
            // $('input[name="ymq[Current Logo]"]').val('');
            $('input[name^="Current Logo]"').val('');
            $('input[name="properties[Current Logo]"]').prop('checked', false);
            var input = event.target;
            const file = input.files[0];
            const maxSize = 15 * 1024 * 1024;
            const validImageTypes = ['image/png', 'image/jpg', 'image/svg', 'image/HEIF', 'image/HEIC', 'image/webp', 'image/jpeg'];

            if (input.files && input.files[0]) {
                if (!validImageTypes.includes(file.type)) {
                    alert("Invalid file type. Please upload a JPG or PNG image.");
                    $(this).val(''); // Clear the input
                    return false;
                }
    
                if (file) {
                    if (file.size > maxSize) {
                        alert("File size exceeds 15 MB");
                        $(this).val('');
                        return false;
                    }
                }
              
                var reader = new FileReader();
                reader.onload = function(e) {
                    if ($(window).width() < 767) {
                        if( isCap ) {
                            $('#selectedImage').attr('src', e.target.result).css({
                                // 'height': '2.953125vw',
                                'width': '24.95312vw',
                                'left': '11vw',
                                'bottom': '58.5vw',
                            });
                        } else {
                            $('#selectedImage').attr('src', e.target.result).css({
                                // 'height': '2.953125vw',
                                'width': '6.953125vw',
                                // 'left': '27.994791666666668vw',
                                // 'top': '21.044270833333334vw',
                            });
                        }

                        if ($('#logo-placement').val() !== '') {
                            $('#selectedImage').show();
                        }
                    } else {
                        if( isCap ) {
                            $('#selectedImage').attr('src', e.target.result).css({
                                // 'height': '2.953125vw',
                                'width': '6.9531vw',
                                'left': '10.67vw',
                                'bottom': '28.5vw',
                            });
                        } else {
                            // if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1) {
                            if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                                $('#selectedImage').attr('src', e.target.result).css({
                                    // 'height': '1.5312vw',
                                    'width': '1.5312vw',
                                    // 'left': '27.994791666666668vw',
                                    // 'top': '21.044270833333334vw',
                                });
                            } else {
                                $('#selectedImage').attr('src', e.target.result).css({
                                    // 'height': '1.35312vw',
                                    'width': '1.85312vw',
                                    // 'left': '27.994791666666668vw',
                                    // 'top': '21.044270833333334vw',
                                });
                            }
                        }

                        if ($('#logo-placement').val() !== '') {
                            $('#selectedImage').show();
                        }
                    }
                };
                reader.readAsDataURL(input.files[0]);
                $("#logo_custom").css("border", "");
                $("#logo_custom").removeAttr("style");
                $(".reallogo").removeAttr("style");
                $(".reallogo_current").removeAttr("style");
            } else {
                $('#selectedImage').attr('src', '');
                $('#selectedImage').css('display', 'none');
            }
        });

        $('#logo-placement').change(function() {
            let logo_placement = $('#logo-placement option:selected').text();
            console.log(logo_placement);
            var ymq_logo_placement = $('select[name^="Logo placement"]');
            console.log(ymq_logo_placement);
            if( $('#logo-placement').val() !== '' ) {
              //$('select[name="ymq[Logo placement]"]').val(logo_placement);
              ymq_logo_placement.val(logo_placement).trigger('change');
            } else {
              //$('select[name="ymq[Logo placement]"]').val('');
              ymq_logo_placement.val('').trigger('change');
            }
            if ($(window).width() < 767) {
                var selectedValue = $(this).val();
              
                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    if (selectedValue == 'left-thigh-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }
                        $('#selectedImage').css('bottom', '75vw');
                        $('#selectedImage').css('right', '35vw');
                        $('#selectedImage').css('left', 'unset');
                    } else if (selectedValue == 'right-thigh-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }
                        $('#selectedImage').css('bottom', '75vw');
                        $('#selectedImage').css('right', 'unset');
                        $('#selectedImage').css('left', '32vw');
                    } else {
                        $('#selectedImage').hide();
                    }
                } else {
                    if (selectedValue == 'left-arm-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        if(productTitle.indexOf('collar scrub') != -1){
                            $('#selectedImage').css('bottom', '73vw');
                            $('#selectedImage').css('right', '23vw');
                            $('#selectedImage').css('left', 'unset');
                        }else{
                            $('#selectedImage').css('bottom', '64vw');
                            $('#selectedImage').css('right', '12vw');
                            $('#selectedImage').css('left', 'unset');
                        }

                    } else if (selectedValue == 'right-arm-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        if(productTitle.indexOf('collar scrub') != -1){
                            $('#selectedImage').css('bottom', '71vw');
                            $('#selectedImage').css('right', 'unset');
                            $('#selectedImage').css('left', '21.528vw');
                        }else{
                            $('#selectedImage').css('bottom', '64vw');
                            $('#selectedImage').css('right', 'unset');
                            $('#selectedImage').css('left', '12.528vw');
                        }

                    } else if (selectedValue == 'left-chest-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }
                        if(productTitle.indexOf('v neck') !== -1){
                            $('#selectedImage').css('bottom', '70.5vw');
                            $('#selectedImage').css('right', '36.195vw');
                            $('#selectedImage').css('left', 'unset');
                        }else{
                            $('#selectedImage').css('bottom', '70.5vw');
                            $('#selectedImage').css('right', '38.195vw');
                            $('#selectedImage').css('left', 'unset');
                        }

                    } else if (selectedValue == 'right-chest-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        $('#selectedImage').css('bottom', '70.5vw');
                        $('#selectedImage').css('right', 'unset');
                        $('#selectedImage').css('left', '30.095vw');
 
                    } else {
                        $('#selectedImage').hide(); 
                    }
                }
            } else {
                var selectedValue = $(this).val();

                if ($('.product__title h1').text().toLowerCase().indexOf('pants') !== -1 && $('.product__title h1').text().toLowerCase().indexOf('top') === -1) {
                    if (selectedValue == 'left-thigh-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }
                        $('#selectedImage').css('left', '29.0948vw');
                        $('#selectedImage').css('top', '12.5vw');
                    } else if (selectedValue == 'right-thigh-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }
                        $('#selectedImage').css('left', '17.7948vw');
                        $('#selectedImage').css('top', '12.5vw');
                    } else {
                        $('#selectedImage').hide();
                    }
                } else {
                    if (selectedValue == 'left-arm-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        if(productTitle.indexOf('collar scrub') != -1){
                            $('#selectedImage').css('left', '33.563vw');
                            $('#selectedImage').css('bottom', '33vw');
                        }else{
                            $('#selectedImage').css('left', '34.563vw');
                            $('#selectedImage').css('bottom', '32vw');
                        }
                    } else if (selectedValue == 'right-arm-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        if(productTitle.indexOf('collar scrub') != -1){
                            $('#selectedImage').css('left', '12.915vw');
                            $('#selectedImage').css('bottom', '33vw');
                        }else{
                            $('#selectedImage').css('left', '11.415vw');
                            $('#selectedImage').css('bottom', '31vw');
                        }
                    } else if (selectedValue == 'left-chest-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        if(productTitle.indexOf('v neck') !== -1){
                            $('#selectedImage').css('left', '26.67vw');
                            $('#selectedImage').css('bottom', '35vw');
                        }else{
                            $('#selectedImage').css('left', '27.67vw');
                            $('#selectedImage').css('bottom', '35vw');
                        }
                    } else if (selectedValue == 'right-chest-as-worn') {
                        if ($('#selectedImage').attr('src') !== undefined && $('#selectedImage').attr('src') !== "") {
                            $('#selectedImage').show();
                        }

                        $('#selectedImage').css('left', '17.717vw');
                        $('#selectedImage').css('bottom', '35vw');

                    } else {
                        $('#selectedImage').hide(); 
                    }
                }
            }

            if( isCap ) {
                console.log('Is cap');
                if ($(window).width() < 767) {
                    $('#selectedImage').css('left', "11vw !important");
                    $('#selectedImage').css('left', "11vw !important");
                    $('#selectedImage').css('right', "unset");
                    $('#selectedImage').css('bottom', "58.5vw !important");
                    $('#selectedImage').css('width', "8.85312vw !important");
                    $('#selectedImage').css('transform', "rotate(14deg)");
                } else {
                    $('#selectedImage').css('left', "8.67vw !important");
                    $('#selectedImage').css('right', "unset");
                    $('#selectedImage').css('bottom', "28vw !important");
                    $('#selectedImage').css('width', "6.85312vw !important");
                    $('#selectedImage').css('transform', "rotate(14deg)");
                }
            }
        });

      // Detect Safari
      function isSafari() {
        return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
      }
      
      // Apply styles if the browser is Safari
      if (isSafari()) {
        $('body').addClass('isSafari');
      }

      // Wait for 2 seconds before starting the observation
      setTimeout(function() {
        // Select the target element (the <label> with the specific class)
        const targetElement = document.getElementsByClassName('ymq_upload_new')[0]; // Access the first element in the collection
      
        if (!targetElement) {
          console.log('Target element not found!');
          return;
        }
      
        // Create a MutationObserver to observe changes in the class attribute
        const logoObserver = new MutationObserver((mutationsList, logoObserver) => {
          mutationsList.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              // Check if the "ymq-btn-progress" class is removed
              if (!targetElement.classList.contains('ymq-btn-progress')) {
                updateTotalPrice_logo(); // Call your function here
              }
            }
          });
        });
      
        // Observer configuration: observe changes to attributes (specifically class)
        const config = { attributes: true };
      
        // Start observing the target element
        logoObserver.observe(targetElement, config);
      
      }, 2000); // Wait for 2 seconds before starting



function simulateTyping(line) {
//   let input = document.querySelector('input[name="ymq[' + line + ']"]');
  let input = document.querySelector('input[name^="' + line + '"]');
  if (!input) return;

  input.focus();

  // Fire "fake" key events so app thinks user interacted
  input.dispatchEvent(new KeyboardEvent('keydown', { key: " ", bubbles: true }));
  input.dispatchEvent(new KeyboardEvent('keypress', { key: " ", bubbles: true }));
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new KeyboardEvent('keyup', { key: " ", bubbles: true }));

  // Fire change + blur to finalize
  input.dispatchEvent(new Event('change', { bubbles: true }));
  input.blur();
}






  $('div.finished').on('click', function() {
    $('.confirm_btn_div_inside').each(function() {
      
        $(this).trigger('click');

    });
   
    
    $('#embroideryModal').hide();
    $('#toggleDiv1').trigger('click');


    simulateTyping("Line 1");   

    $(".product-form__buttons .product-form__submit.button").trigger('click');
  });

});









// slect input 

$(document).ready(function () {
  const $select = $('#name-placement');
  const $radioWrapper = $('#placement-radio-wrapper');

  // Hide original select
  $select.hide();

  // Loop through each option and create corresponding radio buttons
  $select.find('option').each(function () {
    const $option = $(this);
    const value = $option.val();
    const text = $option.text();
    const display = $option.css('display');
    const isSelected = $option.is(':selected');

    const isVisible = display !== 'none';
    const labelStyle = `display: ${isVisible || value === '' ? 'inline-block' : 'none'}; margin-right: 0px;`;

    const radioBtn = `
      <label class="plposset" style="${labelStyle}">
        <input type="radio" name="placement-radio" value="${value}" ${isSelected || value === '' ? 'checked' : ''}>
        ${text}
      </label>
    `;
    $radioWrapper.append(radioBtn);
  });

  // When user changes radio selection, update hidden select value
  $radioWrapper.on('change', 'input[name="placement-radio"]', function () {
    const selectedValue = $(this).val();
    $select.val(selectedValue).change();
  });

  // Ensure default is "None"
  $select.val('').change();
});



$(document).ready(function () {
  const $select = $('#logo-placement');
  const $radioWrapper = $('#placement-radio-wrapper-logo');

  // Hide original select
  $select.hide();

  // Loop through each option and create corresponding radio buttons
  $select.find('option').each(function () {
    const $option = $(this);
    const value = $option.val();
    const text = $option.text();
    const display = $option.css('display');
    const isSelected = $option.is(':selected');

    const isVisible = display !== 'none';
    const labelStyle = `display: ${isVisible || value === '' ? 'inline-block' : 'none'}; margin-right: 0px;`;

    const radioBtn = `
      <label class="plposset" style="${labelStyle}">
        <input type="radio" name="placement-radio-logo" value="${value}" ${isSelected || value === '' ? 'checked' : ''}>
        ${text}
      </label>
    `;
    $radioWrapper.append(radioBtn);
  });

  // When user changes radio selection, update hidden select value
  $radioWrapper.on('change', 'input[name="placement-radio-logo"]', function () {
    const selectedValue = $(this).val();
    $select.val(selectedValue).change();
  });

  // Ensure default is "None"
  $select.val('').change();
});

